/** Inline CTA colors from config hex; primary uses filled background + optional label hex or EB text token. */
export function getInGridCtaInlineStyle(
  ctaStyle: "primary" | "secondary" | "link",
  ctaColor: string,
  ctaPrimaryTextColor: string
): { backgroundColor?: string; borderColor?: string; color: string } | undefined {
  if (!ctaColor) return undefined
  if (ctaStyle === "primary") {
    return {
      backgroundColor: ctaColor,
      borderColor: ctaColor,
      color: ctaPrimaryTextColor || "var(--color-eb-text)"
    }
  }
  return { color: ctaColor }
}
